<template>
  <div v-if="showCompanyGroupDropdown" class="anzera-life-dropdown">
    <!-- Company Group Icon -->
    <a :uk-tooltip="`title: ${companyGroupTitle} ; pos: bottom ;offset:0`"
       class="header-widget-icon" href="javascript:void(0)">
      <i class="uil-building"></i>
    </a>

    <!-- Company Group Dropdown -->
    <div ref="companyGroupRef" class="dropdown-notifications"
         uk-dropdown="pos: top-right;mode:click; animation: uk-animation-slide-bottom-small">
      <!-- Company group header -->
      <div class="dropdown-notifications-headline">
        <p class="current-company-info">{{ currentCompanyMessage }}</p>
      </div>

      <!-- Company group contents -->
      <div class="dropdown-notifications-content" data-simplebar>
        <ul>
          <!-- Parent Company -->
          <li v-if="companyData?.parent" class="parent-company-item">
            <a class="parent-company-link" href="#" @click.prevent="changeCompany(companyData.parent)">
              <i class="uil-building"></i>
              <div class="parent-company-content">
                <span class="navi-text">{{ companyData.parent.name }}</span>
              </div>
              <span class="switch-badge">{{ companyGroupTitle }}</span>
            </a>
          </li>

          <!-- Children Companies -->
          <template v-for="(child, index) in companyData?.children">
            <li :key="'child-' + index" class="sub-company-item">
              <a class="sub-company-link" href="#" @click.prevent="changeCompany(child)">
                <i class="uil-arrow-right"></i>
                <span class="navi-text">{{ child.name }}</span>
                <span class="switch-badge">{{ companyGroupTitle }}</span>
              </a>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { showError, showInfo } from "@/utils/alertUtils";

export default {
  name: "AnzeraLifeDropdown",
  data() {
    return {
      companyData: null,
      loading: false,
    };
  },
  computed: {
    showCompanyGroupDropdown() {
      // is_group_alias true ise ve can_switch_company true sie göster
      return this.companyData?.is_group_alias  && this.companyData?.can_switch_company
    },
    companyGroupTitle() {
      if (this.companyData?.parent) {
        return this.$t('general.switch_to_main_company');
      } else if (this.companyData?.children && this.companyData.children.length > 0) {
        return this.$t('general.switch_to_sub_company')
      }
      return '';
    },
    currentCompanyMessage() {
      // Kullanıcının şu anki kurumu
      if (this.companyData?.parent) {
        // Parent varsa, kullanıcı alt kurumda demektir
        return `${this.$t('general.in_sub_company')} (${this.companyData.name})`;
      } else if (this.companyData?.children && this.companyData.children.length > 0) {
        // Children varsa, kullanıcı ana kurumda demektir
        return `${this.$t('general.in_main_company')} (${this.companyData.name})`;
      }
      return '';
    },
  },
  methods: {
    async fetchCompanyData() {
      if (this.loading) return;

      this.loading = true;
      try {
        const response = await ApiService.get("api/company/self");
        // Orijinal veriyi kullan, Header.vue'daki değişikliklerden etkilenme
        this.companyData = response.data;
      } catch (error) {
        this.companyData = null;
      } finally {
        this.loading = false;
      }
    },
    async changeCompany(company) {
      if (!company || !company.id) {
        return;
      }

      // Dropdown'u kapat
      if (this.$refs.companyGroupRef) {
        UIkit.dropdown(this.$refs.companyGroupRef).hide(0);
      }

      try {
        // Company değiştirme isteği
        const response = await ApiService.post("api/change-company", {
          company_id: company.id
        });

        // Gelen redirect_url'e yeni tab'da yönlendir
        if (response.data.redirect_url) {
          window.open(response.data.redirect_url, '_blank');
        } else {
          // Fallback olarak sayfayı yenile
          window.location.reload();
        }
      } catch (error) {
        // 302 redirect de başarılı sayılır
        if (error.response?.status === 302) {
          window.location.reload();
          return;
        }

        if (error.response?.data?.message) {
          showError(error.response.data.message)
        } else {
          showInfo("Şirket değiştirme işlemi başarısız oldu.")
        }
      }
    },
  },
  mounted() {
    //note: bu istek bşka bir yerde atılıyor ve veri store da tutuluyor , burada bu isteği atmamızın sebebi ise
    //store dak veri referans yöntemi ile değiştirilmiş , bu değiştirlme başka bir yerde kullanılmış ihtimaline karşı düzenleme yapılmadı ve yni bir istek atıldı
    //subCompany.value = response.children; bu ref değişikliği hem header hem de nav alanında yapılmış ,
    // XX.children || XX.parent verisinin oldugu gibi ilk hali ile işlem yapmamaız gerekiyor bu componenttte
    this.fetchCompanyData();
  },
  watch: {
    $route() {
      // Route değiştiğinde dropdown'u kapat
      if (this.$refs.companyGroupRef) {
        UIkit.dropdown(this.$refs.companyGroupRef).hide(0);
      }
    },
  },
};
</script>

<style scoped>
/* Company Group Dropdown Styles */
.current-company-info {
  margin: 8px 0 0 0 !important;
  padding: 8px 12px !important;
  background-color: #f0f9ff !important;
  border-left: 3px solid #3b82f6 !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  color: #1e40af !important;
  font-weight: 500 !important;
  line-height: 1.4 !important;
}

.parent-company-item {
  border-bottom: 1px solid #e5e7eb !important;
  margin-bottom: 8px !important;
  position: relative !important;
}

.parent-company-link {
  background: linear-gradient(135deg, #f8fafc 0%, #e0f2fe 100%) !important;
  font-weight: 600 !important;
  color: #1e40af !important;
  padding: 12px 15px !important;
  display: flex !important;
  align-items: flex-start !important;
  gap: 10px !important;
  border: 1px solid #e0f2fe !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease !important;
  min-height: 50px !important;
  position: relative !important;
  cursor: pointer !important;
  flex-wrap: wrap !important;
}

.parent-company-link:hover {
  background: linear-gradient(135deg, #e0f2fe 0%, #bfdbfe 100%) !important;
  color: #1565c0 !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}

.parent-company-link i {
  flex-shrink: 0 !important;
  font-size: 18px !important;
  color: #3b82f6 !important;
  margin-top: 2px !important;
}

.parent-company-content {
  display: flex !important;
  align-items: flex-start !important;
  flex: 1 !important;
  min-width: 0 !important;
  padding-right: 55px !important;
  flex-direction: column !important;
}

.parent-company-link .navi-text {
  flex: 1 !important;
  font-size: 14px !important;
  line-height: 1.4 !important;
  word-wrap: break-word !important;
  overflow-wrap: break-word !important;
  white-space: normal !important;
  max-width: none !important;
}

.parent-company-badge {
  position: absolute !important;
  top: 0px !important;
  right: 8px !important;
  color: #090909 !important;
  border-radius: 12px !important;
  font-size: 9px !important;
  font-weight: 700 !important;
  white-space: nowrap !important;
  text-transform: uppercase !important;
}

.sub-company-item {
  margin-left: 10px !important;
  margin-bottom: 2px !important;
}

.sub-company-link {
  padding: 8px 12px !important;
  color: #4b5563 !important;
  font-weight: 400 !important;
  border-left: 3px solid transparent !important;
  transition: all 0.2s ease !important;
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  border-radius: 6px !important;
  min-height: 36px !important;
  cursor: pointer !important;
  position: relative !important;
  flex-wrap: wrap !important;
}

.sub-company-link:hover {
  background-color: #f8fafc !important;
  color: #1f2937 !important;
  border-left-color: #3b82f6 !important;
  padding-left: 15px !important;
  transform: translateX(2px) !important;
}

.sub-company-link i {
  color: #9ca3af !important;
  font-size: 12px !important;
  flex-shrink: 0 !important;
}

.sub-company-link .navi-text {
  flex: 1 !important;
  font-size: 13px !important;
  line-height: 1.3 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 200px !important;
}

/* Switch Badge - Sağ Alt */
.switch-badge {
  position: absolute !important;
  bottom: 4px !important;
  right: 8px !important;
  background-color: #10b981 !important;
  color: #ffffff !important;
  padding: 2px 8px !important;
  border-radius: 4px !important;
  font-size: 9px !important;
  font-weight: 600 !important;
  text-transform: lowercase !important;
  white-space: nowrap !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease !important;
}

.parent-company-link:hover .switch-badge,
.sub-company-link:hover .switch-badge {
  background-color: #059669 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15) !important;
  transform: scale(1.05) !important;
}
</style>

